export const chats = [
    {person:'Sudex' , title:"Assalomu Aleykum Sudexga xush kelibsizlar!", createdAt:"21:24"},
    {person:'Sudex' , title:"Sizga qanday yordam berishimiz mumkun?", createdAt:"21:24"},
    {person:'Sudex' , title:"Assalomu Aleykum Sudexga xush kelibsizlar!", createdAt:"21:24"},
    {person:'Sudex' , title:"Assalomu Aleykum Sudexga xush kelibsizlar!", createdAt:"21:24"},
    {person:'Sudex' , title:"Assalomu Aleykum Sudexga xush kelibsizlar!", createdAt:"21:24"},
    {person:'Sudex' , title:"Assalomu Aleykum Sudexga xush kelibsizlar!", createdAt:"21:24"},
    {person:'Sudex' , title:"Assalomu Aleykum Sudexga xush kelibsizlar!", createdAt:"21:24"},
    {person:'Sudex' , title:"Assalomu Aleykum Sudexga xush kelibsizlar!", createdAt:"21:24"},
    {person:'Sudex' , title:"Assalomu Aleykum Sudexga xush kelibsizlar!", createdAt:"21:24"},
    {person:'Sudex' , title:"Assalomu Aleykum Sudexga xush kelibsizlar!", createdAt:"21:24"},
    {person:'Sudex' , title:"Assalomu Aleykum Sudexga xush kelibsizlar!", createdAt:"21:24"},
]